const HeaderLegal = ({ data }) => {
  return (
    <header className="header-legal">
      <div className="header-legal__title">
        <h1>{data.title}</h1>
        <p>{data.update}</p>
      </div>
    </header>
  );
};

export default HeaderLegal;
